import React from 'react';

class TimeSelect2 extends React.Component {
  componentWillMount() {
    this.setTimeSlots(this.props.startTime, this.props.endTime);
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.startTime !== this.props.startTime || nextProps.endTime !== this.props.endTime) {
      this.setTimeSlots(nextProps.startTime, nextProps.endTime);
    }
  }

  setTimeSlots(startTime, endTime) {
    const timeSlots = [];
    let time = '00:00';
    let ampm = 'am';
    let pastStartTime = true;
    let beforeEndTime = true;

    if(startTime) {
      pastStartTime = false;
    }

    for(let i = 0; i < 48; i++) {
      let thisTime;
      let label;

      if(i !== 0) {
        let hr = Number(time.split(':')[0]);
        let min = Number(time.split(':')[1]);

        if(min === 30) {
          hr++;
          min = '00'
        } else if(min === 0) {
          min = 30;
        }

        hr = hr.toString();
        min = min.toString();

        if(hr.length === 1) {
          hr = `0${hr}`;
        }

        thisTime = `${hr}:${min}`;

        time = thisTime;

        if(Number(hr) > 11) {
          ampm = 'pm'
        }

        label = `${time}${ampm}`;

        if(Number(hr) > 12) {
          label = `${hr - 12}:${min}${ampm}`
        } else if(Number(hr) === 0) {
          label = `12:${min}${ampm}`
        }
      } else {
        label = '12:00am';
      }

      if(startTime && time === startTime) {
        pastStartTime = true;
      }

      if(endTime && time === endTime) {
        beforeEndTime = false;
      }

      const timeSlot = {
        value: time,
        label: label
      }

      if(startTime && endTime) {
        if(pastStartTime && beforeEndTime) {
          timeSlots.push(timeSlot);
        }
      } else if(startTime && pastStartTime) {
        timeSlots.push(timeSlot);
      } else if(endTime && beforeEndTime) {
        timeSlots.push(timeSlot);
      } else if(!startTime && !endTime) {
        timeSlots.push(timeSlot);
      }
    }

    this.setState({
      timeSlots
    });
  }

  render() {
    return (
      <optgroup>
        {this.state.timeSlots.map(
          (slot, i) =>
          <option key={i} value={slot.value}>{slot.label}</option>
        )}
      </optgroup>
    )
  }
}

export default TimeSelect2;



// WEBPACK FOOTER //
// ./src/app/components/Modules/TimeSelect2.js